export const isSnapshot = window.navigator.userAgent === "ReactSnap";
